import componentRegistry from '../registry.js';
import getSellerContact from '../../scripts/api/seller/getSellerContact.js';

export default class SellerContact {
  el;
  #sellerRef;

  constructor({ el }) {
    this.el = el;
    if (el.dataset.sellerRef) {
      this.#sellerRef = el.dataset.sellerRef;
      this._callApi();
    }
  }

  _callApi = async () => {
    const maxWidth = parseInt((this.el.offsetWidth - 40) * 0.6);
    const dataHTML = await getSellerContact(this.#sellerRef, maxWidth);

    this.el.innerHTML = dataHTML;
  };
}

componentRegistry.define('js-sellerContact', SellerContact);
